export default function PHP_checkdate() {
  return (
    <div>
      <h1>PHP_checkdate</h1>
    </div>
  );
}
